import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ loggedIn, setLoggedIn }) => {
  return (
    <nav className="navbar">
      <Link to="/">Home</Link>
      <Link to="/cv">CV</Link>
      <Link to="/dashboard">Dashboard</Link>
      {loggedIn && (
        <button onClick={() => setLoggedIn(false)}>Logout</button>
      )}
    </nav>
  );
};

export default Navbar;
